import CustomTitle from "../../components/CustomMiscellaneous/CustomTitle";
import { generalObjectBuilder, genericDelete, genericPost, genericUpdate, paginatedGetWithProcessor } from "../../services/api.service";
import { useLocation } from "react-router-dom";
import { EntregasConfig } from "./configs/Entregas.config";
import Table from '../../components/Table/Table';
import CustomButtonSimple from "../../components/CustomMiscellaneous/CustomButtonSimple";
import AddIcon from '@mui/icons-material/Add';
import { useState } from "react";
import HorizontalRule from "../../components/HorizontalRule/HorizontalRule";
import { EntregasForm } from "./EntregasForm";


export default function EntregasTable() {

    const location = useLocation();
    const currentRoute = location.pathname;
    const obraId = currentRoute.split("/")[2];

    const EXTENSION = `/obras/${obraId}/entregas`;

    const [editing, setEditing] = useState(false);

    return (<>{EXTENSION ? <div>

        <div className="px-4">
            <div className="flex items-center px-5 justify-between pr-20">
                <CustomTitle text={"Entregas"} />
                {editing ? null : <CustomButtonSimple text={"Adicionar entrega"} onClick={() => setEditing(true)} Icon={AddIcon} />}
            </div>
            <HorizontalRule />
        </div>

        {editing ? <div>
                <EntregasForm onCancel={()=> setEditing(false)}/>
        </div> : <div className="mx-10">
            <Table
                configMapKey={`obras/${obraId}/entregas`}
                tableConfigs={EntregasConfig}
                hidePagination={true}
                isSubTable={true}
                hideFilters={true}
                idProp={"id"}
                entityName={"Entregas"}
                title={"Entregas"}
                dataBuildFunction={generalObjectBuilder(EntregasConfig)}
                allowCopy={false}
                generatePdf={false}
            /></div>}
        
    </div> : null}</>)

}